<rap-add-edit-students-ui [editableStudent]="editableStudent$ | async" [errorMessage]="errorMessage$ | async"
  (createNewStudentEmitter)="createNewStudent($event)" (updateStudentEmitter)="updateStudent($event)"
  [rosterId]="rosterId" [studentId]="studentId"></rap-add-edit-students-ui>